import { TermsAndConditionsModel } from "src/app/models/common/terms-and-conditions.model";
import { CurrencyModel } from "../../../models/currency_master_model/currency";

export interface ILeaseQuoteModel {
  id?: string;
  lead: string;
  per_diem_charge: number;
  per_diem_charge_currency: string;
  negotiation_percent: number;
  min_manufacturing_year: number;
  max_manufacturing_year: number;
  tentative_pickup_date: Date;
  remarks: string;
  request_number?: string;
  quantity: number;
  terms_and_condition_fk: string | TermsAndConditionsModel;
  terms_and_condition_text: string;
}

export interface ILeaseQuoteError {
  per_diem_charge: string[];
  per_diem_charge_currency: string[];
  negotiation_percent: string[];
  min_manufacturing_year: string[];
  max_manufacturing_year: string[];
  tentative_pickup_date: string[];
  remarks: string[];
  terms_and_condition_fk: string[];
  terms_and_condition_text: string[];
}

export class LeaseQuoteModel {
  id?: string;
  lead: string;
  per_diem_charge: number;
  per_diem_charge_currency: string;
  negotiation_percent: number;
  min_manufacturing_year: number;
  max_manufacturing_year: number;
  tentative_pickup_date: Date;
  remarks: string;
  request_number: string;
  quantity: number;
  terms_and_condition_fk: string | TermsAndConditionsModel;
  terms_and_condition_text: string;

  error: ILeaseQuoteError;

  validations = {
    tentative_pickup_date: {
      minDate: new Date(),
    },
    negotiation_percent: {
      min: 0,
      max: 30,
    },
    max_manufacturing_year: {
      min: 1980,
      max: new Date().getFullYear(),
    },
    min_manufacturing_year: {
      min: 1980,
      max: new Date().getFullYear(),
    }
  }

  constructor(lead: string) {
    this.id = null;
    this.lead = lead;
    this.per_diem_charge = null;
    this.per_diem_charge_currency = 'USD';
    this.negotiation_percent = 10;
    this.min_manufacturing_year = 2000;
    this.max_manufacturing_year = new Date().getFullYear();
    this.tentative_pickup_date = null;
    this.remarks = null;
    this.request_number = null;
    this.quantity = null;
    this.terms_and_condition_fk = null;
    this.terms_and_condition_text = null;

    this.resetErrors();
  }

  resetErrors() {
    this.error = {
      per_diem_charge: [],
      per_diem_charge_currency: [],
      negotiation_percent: [],
      min_manufacturing_year: [],
      max_manufacturing_year: [],
      tentative_pickup_date: [],
      remarks: [],
      terms_and_condition_fk: [],
      terms_and_condition_text: [],
    }
  }

  validate_min_manufacturing_year() {
    this.error.min_manufacturing_year = [];
    if (this.min_manufacturing_year < this.validations.min_manufacturing_year.min) {
      this.error.min_manufacturing_year.push(`Minimum manufacturing year cannot be less than ${this.validations.min_manufacturing_year.min}`);
    }
  }

  validate_max_manufacturing_year() {
    this.error.max_manufacturing_year = [];
    if (this.max_manufacturing_year > this.validations.max_manufacturing_year.max) {
      this.error.max_manufacturing_year.push(`Maximum manufacturing year cannot be greater than ${this.validations.max_manufacturing_year.max}`);
    }
  }

  is_valid() {

    this.validate_max_manufacturing_year();
    this.validate_min_manufacturing_year();

    return Object.keys(this.error).map((key) => {
      return this.error[key].length;
    }
    ).reduce((a, b) => a + b, 0) == 0;
  }

  getSavePayload(): ILeaseQuoteModel {
    return {
      lead: this.lead,
      per_diem_charge: this.per_diem_charge,
      per_diem_charge_currency: this.per_diem_charge_currency,
      negotiation_percent: this.negotiation_percent,
      min_manufacturing_year: this.min_manufacturing_year,
      max_manufacturing_year: this.max_manufacturing_year,
      tentative_pickup_date: this.tentative_pickup_date,
      remarks: this.remarks,
      quantity: this.quantity,
      terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
      terms_and_condition_text: this.terms_and_condition_text,
    }
  }

  savePayloadToModel(payload: ILeaseQuoteModel) {
    this.id = payload.id;
    this.lead = payload.lead;
    this.per_diem_charge = payload.per_diem_charge;
    this.per_diem_charge_currency = payload.per_diem_charge_currency;
    this.negotiation_percent = payload.negotiation_percent;
    this.min_manufacturing_year = payload.min_manufacturing_year;
    this.max_manufacturing_year = payload.max_manufacturing_year;
    this.tentative_pickup_date = payload.tentative_pickup_date;
    this.remarks = payload.remarks;
    this.request_number = payload.request_number;
    this.terms_and_condition_fk = payload.terms_and_condition_fk;
    this.terms_and_condition_text = payload.terms_and_condition_text;
  }


}
